module.exports = __webpack_public_path__ + "media/img/pages/companies/ost-de-0754d7e8fe0833a7ec5923e3911e2478.webp";